import { render } from "./CatCuentaContableView.vue?vue&type=template&id=396b5f9a&scoped=true"
import script from "./CatCuentaContableView.vue?vue&type=script&lang=js"
export * from "./CatCuentaContableView.vue?vue&type=script&lang=js"

import "./CatCuentaContableView.vue?vue&type=style&index=0&id=396b5f9a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396b5f9a"]])

export default __exports__